export default {
    state() {
        return {
            component: '',
            options: {
                dialog: {
                    visible: false
                }
            },
            result: {}
        }
    },
    getters: {
        modalSettings: state => state,
        modalResult: (state, getters, module) => {
            return module.modal.result
        },
    },
    mutations: {
        changeModalState(state, settings) {
            state.result = {}
            state.component = settings.component
            state.options = settings.options
        },
        changeModalDialogVisible(state, visible) {
            state.options.dialog.visible = visible
        },
        changeModalResult(state, result) {
            state.result = result
        }
    },
    actions: {
        modal(context, settings) {
            context.commit('changeModalState', settings)
        },
        hideModal(context) {
            context.commit('changeModalDialogVisible', false)
        },
        resultModal(context, result) {
            context.commit('changeModalResult', result)
        }
    }
}